import UIComponent from "../../ui/component";
import api from "../../api";
import { TabsDragReorder } from "./TabsDragReorder";
export class ResultTabsList extends UIComponent {
    #dragReorder = null;

    init() {
        this.on("click", this.handleClick.bind(this));
        this.#dragReorder = new TabsDragReorder(this.element, {
            onSelect: (tabId) => this.parent?.handleTabSelect?.(tabId),
            onReorder: () => {
                const orders = this.#dragReorder?.getOrder?.() || [];
                const tab = document.querySelector?.(
                    '.result-tabs__item[data-tab-update-url][data-is-ai-tab="0"]'
                );
                const url = tab?.getAttribute?.("data-tab-update-url");
                if (!url) return;
                api.post(url, { orders: orders });
            },
            shouldIgnoreTarget: (target) =>
                !!target?.closest?.(".result-tabs__delete"),
        });
        this.element.addEventListener("pointerdown", (e) =>
            this.#dragReorder.handlePointerDown(e)
        );
    }

    handleClick(e) {
        const target = e.target;
        const tabItem = target.closest(".result-tabs__item");
        if (!tabItem) return;

        if (target.closest(".result-tabs__delete")) {
            const tabName =
                tabItem
                    .querySelector(".result-tabs__tab")
                    ?.textContent?.trim() || "";
            const deleteUrl =
                target
                    .closest(".result-tabs__delete")
                    ?.getAttribute("data-tab-url") || null;
            const tabId = tabItem.getAttribute("data-id");

            this.parent?.handleTabDeleteRequest?.({
                tabId,
                tabName,
                deleteUrl,
                source: "desktop",
            });
            return;
        }
    }

    getActiveItem() {
        return this.find(".result-tabs__item--active");
    }

    getActiveId() {
        return this.getActiveItem()?.getAttribute("data-id") || null;
    }

    setActive(tabEl) {
        this.findAll(".result-tabs__item").forEach((el) =>
            el.classList.remove("result-tabs__item--active")
        );
        tabEl?.classList?.add("result-tabs__item--active");
    }

    setActiveById(tabId) {
        const el = this.find(`[data-id="${tabId}"]`);
        if (el) this.setActive(el);
        return el;
    }

    insertAfterActive(el) {
        const active = this.getActiveItem();
        if (!active || !el) return;
        active.insertAdjacentElement("afterend", el);
    }

    removeById(tabId) {
        this.find(`[data-id="${tabId}"]`)?.remove();
    }
}
